import React, { useRef, useState, useEffect } from 'react';
import ImageMarker from 'react-image-marker';
import { MapInteractionCSS } from 'react-map-interaction';

import { MainContent, PageHeading } from '../../components/Shell/Content';
import * as pdfjsLib from 'pdfjs-dist';
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
	'pdfjs-dist/build/pdf.worker.min.mjs',
	import.meta.url
  ).toString();
  
const CustomMarker = (props) => {
	return (
		<div class="flex-none rounded-full bg-green-400/10 p-1 text-green-400">
			<div class="h-2 w-2 rounded-full bg-current"></div>
		</div>
	);
};

const PDFCanvas = () => {
	const canvasRef = useRef(null);
	const [pdfFile, setPdfFile] = useState(null);
	const [scale, setScale] = useState(1.5);
	const point = [100, 200]; // Example point in PDF space (you can make this dynamic)

	useEffect(() => {
		const renderPdf = async () => {
			if (!pdfFile) return;

			const fileReader = new FileReader();
			fileReader.onload = async function () {
				const typedarray = new Uint8Array(this.result);

				const pdf = await pdfjsLib.getDocument({ data: typedarray }).promise;
				const page = await pdf.getPage(1);
				const viewport = page.getViewport({ scale });

				const canvas = canvasRef.current;
				const context = canvas.getContext('2d');

				canvas.width = viewport.width;
				canvas.height = viewport.height;

				// Render PDF page
				await page.render({ canvasContext: context, viewport }).promise;

				// Draw marker at the point (adjusted for coordinate system)
				const [x, y] = point;
				const canvasX = x * scale;
				const canvasY = (viewport.height / scale - y) * scale;

				context.fillStyle = 'red';
				context.beginPath();
				context.arc(canvasX, canvasY, 5, 0, 2 * Math.PI);
				context.fill();
			};

			fileReader.readAsArrayBuffer(pdfFile);
		};

		renderPdf();
	}, [pdfFile, scale]);

	return (
		<div>
			<input
				type="file"
				accept="application/pdf"
				onChange={(e) => {
					const file = e.target.files[0];
					if (file) setPdfFile(file);
				}}
			/>
			<br />
			<canvas
				ref={canvasRef}
				style={{ border: '1px solid #ccc', marginTop: 10 }}
			/>
		</div>
	);
};

const Map = () => {
	const mapRef = useRef();

	const [markers, setMarkers] = useState([]);
	const [mapValue, setMapValue] = useState({
		scale: 1,
		translation: { x: 0, y: 0 },
	});

	return (
		<MainContent>
			<PageHeading>Overview Map</PageHeading>

			<PDFCanvas />

			<div className="border h-100">
				<MapInteractionCSS
					value={mapValue}
					minScale={1}
					maxScale={3}
					/*translationBounds={{
						xMax: 200,
						xMin: -200,
						yMax: 100,
						yMin: -100,
					}}*/
					onChange={(value) => {
						const plusMinus = value?.scale < mapValue?.scale ? -0.1 : 0.1;
						setMapValue({
							scale: value?.scale, //+ plusMinus,
							translation: value?.translation,
						});
					}}
				>
					<div ref={mapRef} className="mb-10">
						{/*<img
							src={Floorplan}
							width={2432}
							height={1442}
							className="mt-16 rounded-md bg-white/5 shadow-2xl ring-1 ring-white/10 sm:mt-24 mb-16"
                />*/}
						Width: {mapRef?.current?.offsetWidth}
					</div>
					{/*<ImageMarker
						src={Floorplan}
						markers={markers}
						onAddMarker={(marker, e) => {
							if (!e.defaultPrevented) {
								setMarkers([...markers, marker]);
							}
						}}
						markerComponent={CustomMarker}
					/>*/}
				</MapInteractionCSS>
			</div>
		</MainContent>
	);
};

export default Map;
